import { apiProvider } from "./provider";

export class ApiCore {
  constructor(options) {
    if (options.get) {
      this.get = (data) => {
        if (typeof data === "undefined") return apiProvider.get(options.url);
        else return apiProvider.get(options.url + data);
      };
    }

    if (options.post) {
      this.post = (data) => {
        return apiProvider.post(options.url, data);
      };
    }
  }
}

export class ApiProvider {
  constructor(options) {
    if (options.get) {
      this.get = (url, data) => {
        if (typeof data === "undefined") return apiProvider.get(url);
        else return apiProvider.get(url + data);
      };
    }

    if (options.post) {
      this.post = (url, data) => {
        return apiProvider.post(url, data);
      };
    }
  }
}
